export default __webpack_public_path__ + "static/media/18.273d24d8.png";